import { RIGHT_TO_LEFT_LANGS } from '@/utils/i18n'

const SUPPORTED_LANG_LIST = ['en', 'ar']
const DEFAULT_LANG = 'ar'

const getLangByLocale = (locale) => {
  if (!TypeChecker.isString(locale)) {
    return DEFAULT_LANG
  }

  const [initLang] = locale.replace('-', '_').split('_') || []

  if (!SUPPORTED_LANG_LIST.includes(initLang)) {
    return DEFAULT_LANG
  }

  return initLang
}

const setAttributesByLocale = (locale) => {
  // Defer set up lang and dir attribute in html to get session data
  const $doc = document.getElementsByTagName('html')[0]

  if ($doc) {
    const initLang = getLangByLocale(locale)
    const initDirection = RIGHT_TO_LEFT_LANGS.includes(initLang) ? 'rtl' : 'ltr'

    $doc.setAttribute('lang', initLang)
    $doc.setAttribute('dir', initDirection)
  }
}

export { DEFAULT_LANG, SUPPORTED_LANG_LIST, getLangByLocale }

export default setAttributesByLocale
